module.exports = __webpack_public_path__ + "files/feed6c70fde629d6eb61e1ed2bb93537.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size1-Regular.woff2
// module id = 1673
// module chunks = 60